// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__PL0qO","cardText":"Card_cardText__GqCkX","name":"Card_name__vpWb5","info":"Card_info__fIRs3"};